import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import Button from "./ui/Button";

const WarningModal = ({ timeLeft, onLogout, onExtendSession }) => {


    return (
        <Modal show={true} centered className="custom-swal-modal">
            <Modal.Body className="text-center p-5">
                <h5 className="text-danger fw-bold font-size-16 mb-3">Warning !</h5>
                <div className="mx-auto mb-3">
                    <i className={"fa fa-info-circle"} style={{ color: 'rgb(200, 96, 94)', fontSize: '50px' }}></i>
                </div>
                <p className="modal-message fw-bold mb-4">
                    Your session is about to be timed out in{" "}
                    <span className="text-danger fw-bold">({timeLeft} seconds)</span>.
                    What would you like to do?
                </p>
                <div className="modal-actions">
                    <button className="btn-logout me-4" title="Log me out" onClick={onLogout}>Log me out</button>
                    <button className="btn-extend" title="Keep me logged in" onClick={onExtendSession}>Keep me logged in</button>
                </div>
            </Modal.Body>
        </Modal>
    );


    // only use latest version of sweetalert2 [11.21.2]

    // const swalInstance = useRef(null); // Store the Swal instance

    // const showWarningAlert = () => {
    //     Swal.fire({
    //         title: "Warning!",
    //         html: `
    //             <p style="font-size: 1.2rem; font-weight: normal;">
    //                 Your session is about to be timed out in 
    //                 <span style="color: #c8605e; font-weight: bold;">(${timeLeft} seconds)</span>.
    //                 What would you like to do?
    //             </p>
    //         `,
    //         icon: 'info',
    //         showCancelButton: true,
    //         confirmButtonText: "Keep me logged in",
    //         cancelButtonText: "Log me out",
    //         buttonsStyling: true,
    //         allowOutsideClick: false,
    //         allowEscapeKey: false,
    //         customClass: {
    //             confirmButton: "btn button-primary",
    //             cancelButton: "btn button-secondary"
    //         },
    //         reverseButtons: true,
    //         didOpen: () => {
    //             swalInstance.current = Swal; // Save the instance of Swal when it's opened
    //         },
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             onExtendSession();
    //         } else if (result.isDismissed) {
    //             onLogout();
    //         }
    //         swalInstance.current = null; // Clear the instance when the modal is closed
    //     });
    // };

    // useEffect(() => {
    //     if (!swalInstance.current) {
    //         // Show the modal if it's not already open
    //         showWarningAlert();
    //     } else {
    //         // Update the modal content dynamically
    //         swalInstance.current.update({
    //             html: `
    //                 <p style="font-size: 1.2rem; font-weight: normal;">
    //                     Your session is about to be timed out in 
    //                     <span style="color: #c8605e; font-weight: bold;">(${timeLeft} seconds)</span>.
    //                     What would you like to do?
    //                 </p>
    //             `,
    //         });
    //     }
    // }, [timeLeft]); // Re-run whenever timeLeft changes

    // return null; // No UI rendered by the component
};

export default WarningModal;
